<div class="container-fluid px-md-5 pt-5">
  <div class="row">
    <div class="container-fluid px-md-5 px-1">
      <div class="d-flex w-100 flex-column align-items-center mb-5">
        <p class="fs-2 fw-bold lh-lg">{{ "imakeapp system" | translate }}</p>
        <p class="fs-5 text-center">
          {{
            "The latest rental car management program in the Arab world"
              | translate
          }}
        </p>
        <a href="https://carsys.codesroots.com/login" target="_blank">
          <button class="btn btn-warning fw-bold fs-4 px-5 mt-3">
            {{ "Try it now" | translate }}
          </button>
        </a>
        <div class="my-3 col-md-12 text-center">
          <span class="fs-6">{{
            "username: admin  | password: 123456" | translate
          }}</span>
        </div>
      </div>
    </div>
    <div class="col-md-6">
      <img
        class="w-100"
        src="../../../../../assets/images/WhatsApp Image 2023-02-28 at 4.39.06 PM.jpeg"
        alt=""
      />
    </div>
    <div class="col-md-6 mt-5">
      <p class="text-right mb-4">
        {{
          "The saascar system offers you the perfect solution to manage your company with ease through a set of programming and management products that give you complete control over your company and your cars."
            | translate
        }}
      </p>
      <p class="text-right mb-4">
        {{
          "Simply, through a group of departments within the system, you will manage Your entire company and access to contracts and their establishment, reports and financials, as well as maintenance of your cars, violations and administrative renewals for them"
            | translate
        }}
      </p>
      <p class="text-right mb-4">
        {{
          "It will also allow you to join us in displaying your cars in the largest car rental platform in the Arab world, so that you can rent your cars and increase your sales with ease."
            | translate
        }}
      </p>
    </div>
  </div>

  <!-- ############################################################################# -->
  <div class="d-flex mt-md-8 section-box row">
    <div class="col-md-7">
      <h1 class="list-items fw-bold fs-3 mb-4">
        {{ "Vehicle management" | translate }}
      </h1>
      <p class="list-items line-height-1 fs-5 mb-5">
        {{
          "The saascar system contains the management of vehicles and the role of this department in the system is the comprehensive management of the company's vehicles, adding them, displaying their details and contracts, as well as the amounts of their revenues and costs and the difference between them"
            | translate
        }}
      </p>
    </div>

    <div class="col-md-5 sub-box mt-md--11 restaurant-customers">
      <div class="d-flex justify-content-center">
        <div class="position-relative">
          <img
            src="../../../assets/images/imakeapp-cars/iPhone XR Design Mockup-freebies.png"
            alt="woman ordering food using mobile"
            class="img-1 img-section-1"
          />
        </div>
      </div>
    </div>
    <div class="col-md-7">
      <ul class="points-list list-unstyled d-flex flex-column gap-3">
        <li *ngFor="let clientsAppFeature of Section1content">
          <p class="list-items">
            {{ clientsAppFeature | translate }}
          </p>
        </li>
      </ul>
    </div>
    <div class="col-md-5 d-flex align-items-end mt-3">
      <ul class="text-end points-list list-unstyled d-flex flex-column gap-3">
        <li *ngFor="let clientsAppFeature of Section2content">
          <p class="list-items">
            {{ clientsAppFeature | translate }}
          </p>
        </li>
      </ul>
    </div>
  </div>

  <!-- ############################################################################# -->
  <div class="d-flex mt-md-8 section-box row">
    <div class="col-md-7">
      <h1 class="list-items fw-bold fs-3 mb-4">
        {{ "Managing violations" | translate }}
      </h1>
      <p class="list-items line-height-1 fs-5 mb-5">
        {{
          "The saascar system contains a management of violations, and the role of this department in the system is the comprehensive management of vehicle violations"
            | translate
        }}
      </p>
    </div>

    <div class="col-md-5 sub-box mt-md--11 restaurant-customers">
      <div class="d-flex justify-content-center">
        <div class="position-relative mt-7">
          <img
            src="../../../assets/images/imakeapp-cars/mockup-2.png"
            alt="woman ordering food using mobile"
            class="img-1 img-section-1"
          />
        </div>
      </div>
    </div>
    <div class="col-md-7">
      <ul class="points-list list-unstyled d-flex flex-column gap-3">
        <li *ngFor="let clientsAppFeature of Section3content">
          <p class="list-items">
            {{ clientsAppFeature | translate }}
          </p>
        </li>
      </ul>
    </div>
  </div>
  <!-- ############################################################################# -->

  <div class="d-flex mt-md-8 section-box row">
    <div class="col-md-7">
      <h1 class="list-items fw-bold fs-3 mb-4">
        {{ "Maintenance Management" | translate }}
      </h1>
      <p class="list-items line-height-1 fs-5 mb-5">
        {{
          "To ensure the safety of the company's cars, you must manage its maintenance professionally, and this is what we manage for you"
            | translate
        }}
      </p>
    </div>

    <div class="col-md-5 sub-box mt-md--11 restaurant-customers">
      <div class="d-flex justify-content-center">
        <div class="position-relative mt-7">
          <img
            src="../../assets/images/Group 1223.svg"
            alt="woman ordering food using mobile"
            class="img-1 img-section-1"
          />
        </div>
      </div>
    </div>
    <div class="col-md-7">
      <ul class="points-list list-unstyled d-flex flex-column gap-3">
        <li *ngFor="let clientsAppFeature of Section4content">
          <p class="list-items">
            {{ clientsAppFeature | translate }}
          </p>
        </li>
      </ul>
    </div>
  </div>
  <!-- ############################################################################# -->

  <div class="d-flex mt-md-8 section-box row">
    <div class="col-md-7">
      <h1 class="list-items fw-bold fs-3 mb-4">
        {{ "Contract Management" | translate }}
      </h1>
      <p class="list-items line-height-1 fs-5 mb-5">
        {{
          "Organizing your business is our goal, so we have taken great care in managing contracts because it is based on organizing the company's revenues completely. Here are the most important features of management"
            | translate
        }}
      </p>
    </div>

    <div class="col-md-5 sub-box mt-md--11 restaurant-customers">
      <div class="d-flex justify-content-center">
        <div class="position-relative mt-7">
          <img
            src="../../assets/images/Group 1340.svg"
            alt="woman ordering food using mobile"
            class="img-1 img-section-1"
          />
        </div>
      </div>
    </div>
    <div class="col-md-7">
      <ul class="points-list list-unstyled d-flex flex-column gap-3">
        <li *ngFor="let clientsAppFeature of Section5content">
          <p class="list-items">
            {{ clientsAppFeature | translate }}
          </p>
        </li>
      </ul>
    </div>
    <div class="col-md-5 d-flex align-items-end mt-3">
      <ul class="text-end points-list list-unstyled d-flex flex-column gap-3">
        <li *ngFor="let clientsAppFeature of Section6content">
          <p class="list-items">
            {{ clientsAppFeature | translate }}
          </p>
        </li>
      </ul>
    </div>
  </div>

  <!-- ########scfsfddssssssssssssssssssssssssss##################################################################### -->

  <div class="row mt-5 px-md-5 px-1 py-3">
    <div class="col-md-5 d-flex mb-2">
      <img
        src="../../assets/images/Group 1342.svg"
        alt=""
        class="device-img w-100"
      />
    </div>
    <div class="col-md-7 d-flex flex-column justify-content-center gap-3">
      <p class="fs-3 fw-bold text-start">
        {{ "Companies Management" | translate }}
      </p>
      <p class="text-start">
        {{
          "If you deal with companies on an ongoing basis in lease contracts, the saascar system provides you with a management to add and display companies and also create their own contracts. It also provides you with comprehensive reports on the companies’ contracts and their revenues."
            | translate
        }}
      </p>
    </div>
  </div>
  <!-- ############################################################################# -->
  <!-- ########scfsfddssssssssssssssssssssssssss##################################################################### -->

  <div class="row mt-5 px-md-5 px-1 py-3">
    <div class="col-md-5 d-flex mb-2">
      <img
        src="../../assets/images/Group 1339.svg"
        alt=""
        class="device-img w-100"
      />
    </div>
    <div class="col-md-7 d-flex flex-column justify-content-center gap-3">
      <p class="fs-3 fw-bold text-start">
        {{ "Customer management" | translate }}
      </p>
      <p class="text-start">
        {{
          "You can register an infinite number of clients, create contracts for them, and also make reports about your clients with ease. Identify some banned clients to not deal with them again."
            | translate
        }}
      </p>
    </div>
  </div>
  <!-- ############################################################################# --><!-- ########scfsfddssssssssssssssssssssssssss##################################################################### -->

  <div class="row mt-5 px-md-5 px-1 py-3">
    <div class="col-md-5 d-flex mb-2">
      <img
        src="../../assets/images/Group 1361.svg"
        alt=""
        class="device-img w-100"
      />
    </div>
    <div class="col-md-7 d-flex flex-column justify-content-center gap-3">
      <p class="fs-3 fw-bold text-start">
        {{ "Human Resource Management" | translate }}
      </p>
      <p class="text-start">
        {{
          "To organize your human resources within the company, you will need the saascar program in a large way, as it allows you to add human resources and manage them, as well as make reports for them, create maintenance contracts and administrative contracts, and allocate them to a specific employee. We also provide you with a special section for salaries and administrative expenses for employees"
            | translate
        }}
      </p>
    </div>
  </div>
  <!-- ############################################################################# -->

  <div class="row mt-5 px-md-5 px-1 py-3">
    <div class="col-md-5 d-flex mb-2">
      <img
        src="../../../assets/images/imakeapp-cars/Device.png"
        alt=""
        class="device-img w-100"
      />
    </div>
    <div class="col-md-7 d-flex flex-column justify-content-center gap-3">
      <p class="fs-3 fw-bold text-start">
        {{ "Comprehensive dashboard" | translate }}
      </p>
      <p class="text-start">
        {{
          "Through the site, you can add a car rental contract so that the legal procedures can be completed and the validity contract for that traffic will be in addition to the direct access to the system"
            | translate
        }}
      </p>
      <p class="fs-3 fw-bold text-start">{{ "multilanguage" | translate }}</p>
      <p class="text-start">
        {{
          "There is no need to worry anymore about the inability to master the languages of the programs, as we would like to be fully aware that one of the priorities of our programs is to help the customer as much as possible to amend them whenever needed to finish his work and arrange it smoothly and solve all the technical obstacles that prevent him from working on our programs, for this we have Adding the feature of multilingualism"
            | translate
        }}
      </p>
    </div>
  </div>
</div>
